"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectIsLoadElementsOptionsChanged = exports.selectHasNextPage = exports.selectLoadNextElementsPageOptions = exports.selectLoadNextElementsPageError = exports.selectLoadNextElementsPageStatus = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var toolkit_1 = require("@reduxjs/toolkit");
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var omit_1 = tslib_1.__importDefault(require("lodash/omit"));
var selectors_1 = require("../common/selectors");
var elementsSelectors_1 = require("../elements/elementsSelectors");
/**
 * @internal
 */
exports.selectLoadNextElementsPageStatus = toolkit_1.createSelector(selectors_1.selectState, function (state) { return state.elements.nextPageLoad.status; });
/**
 * @internal
 */
exports.selectLoadNextElementsPageError = toolkit_1.createSelector(selectors_1.selectState, function (state) { return state.elements.nextPageLoad.error; });
/**
 * @internal
 */
exports.selectLoadNextElementsPageOptions = toolkit_1.createSelector(elementsSelectors_1.selectLastLoadedElementsOptions, function (options) {
    return tslib_1.__assign(tslib_1.__assign({}, options), { offset: options.offset + options.limit });
});
/**
 * @internal
 */
exports.selectHasNextPage = toolkit_1.createSelector(elementsSelectors_1.selectLastLoadedElementsOptions, elementsSelectors_1.selectElementsTotalCount, function (lastLoadedOptions, totalCount) {
    return lastLoadedOptions.offset + lastLoadedOptions.limit < totalCount;
});
/**
 * @internal
 */
exports.selectIsLoadElementsOptionsChanged = toolkit_1.createSelector(elementsSelectors_1.selectLoadElementsOptions, elementsSelectors_1.selectLastLoadedElementsOptions, function (loadOptions, lastLoadedOptions) {
    return !isEqual_1.default(omit_1.default(loadOptions, "offset", "excludePrimaryLabel"), omit_1.default(lastLoadedOptions, "offset", "excludePrimaryLabel"));
});
//# sourceMappingURL=loadNextElementsPageSelectors.js.map